import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import toGetCurrentUser from '@/store/modules/toGetCurrentUser.js';
import toGetCurrentEvent from '@/store/modules/toGetCurrentEvent.js';
import toGetCurrentRegistration from '@/store/modules/toGetCurrentRegistration.js';
import toGetMyThesisList from '@/store/modules/toGetMyThesisList.js';

//注册状态管理全局参数
const index = new Vuex.Store({
  modules: {
    toGetCurrentUser,
    toGetCurrentEvent,
    toGetCurrentRegistration,
    toGetMyThesisList,
  },
  state: {
    openLoginBox: false,
    openRegisterBox: false,
  },
  mutations: {
    blOpenLoginBox(state, v) {
      state.openLoginBox = v;
    },
    blOpenRegisterBox(state, v) {
      state.openRegisterBox = v;
    },
  },
});
export default index;
